import { h } from 'preact'
import { useStateValue } from '../../state-management/store'
import { BookingStep } from '../../models/enums'
import globalVars from '../../shared/global'
import {
    fetchPatient,
    changeStep,
    cancelPatientHasAppointmentsInLast7DaysModal,
    proceedPatientHasAppointmentsInLast7DaysModal,
} from '../../state-management/actions'
import { StepBody } from '../step-body'
import { SelfSchedulerFooter } from '../self-scheduler-footer'
import { PatientForm } from '../patient-form'
import { PatientHasAppointmentInLast7DaysModal } from '../patient-has-appointment-in-last-7-days-modal'
import { ErrorMessage } from '../error-message'
import * as style from './style.css'

const ExistingPatientForm: preact.FunctionalComponent = () => {
    const [
        {
            patientDetails,
            errorMessage,
            submitting,
            selectedLocationId,
            locations,
            patientHasAppointmentInLast7DaysModal,
            showAdditionalDetailsForm,
        },
        dispatch,
    ] = useStateValue()

    const isValid = () => {
        const {
            firstName,
            lastName,
            dateOfBirth,
            phone,
            emailAddress,
            reasonOfAppointment,
            hasInsurance,
        } = patientDetails
        return [firstName, lastName, dateOfBirth, phone, emailAddress, reasonOfAppointment, hasInsurance].every(
            (field) => field.isValid
        )
    }

    const nextStep = showAdditionalDetailsForm ? BookingStep.ADDITIONAL_INFO : BookingStep.DATETIME
    const backStep = globalVars.isRSVP ? undefined : BookingStep.PATIENT_TYPE

    const submitHandler = async () => {
        if (!isValid()) {
            return
        }

        const selectedLocation = locations.find(({ id }) => id === selectedLocationId)
        const contactPhone = selectedLocation?.phoneNumber || ''

        const patient = await fetchPatient(dispatch, {
            patientDetails,
            locationId: selectedLocationId,
            contactPhone,
        })

        if (!patient) {
            return
        }

        changeStep(dispatch, nextStep)
    }

    const closeModal = async () => {
        await cancelPatientHasAppointmentsInLast7DaysModal(dispatch)
    }

    const handleProceed = async () => {
        await proceedPatientHasAppointmentsInLast7DaysModal(dispatch, patientHasAppointmentInLast7DaysModal.patientId)
        changeStep(dispatch, nextStep)
    }

    return (
        <section class={style.patientFormContainer}>
            <StepBody>
                {Boolean(errorMessage) && <ErrorMessage>{errorMessage}</ErrorMessage>}
                <div class={style.patientFormWrapper}>
                    <PatientForm />
                </div>
                <PatientHasAppointmentInLast7DaysModal
                    isOpen={patientHasAppointmentInLast7DaysModal.isModalOpen}
                    closeModal={closeModal}
                    handleProceed={handleProceed}
                />
            </StepBody>
            <SelfSchedulerFooter backStep={backStep} onNext={submitHandler} isNextDisabled={!isValid() || submitting} />
        </section>
    )
}

export default ExistingPatientForm
